
import { useState, useEffect } from 'react';
import { getAnimationClass } from './../utils';

import FinancialStatement from '../../../thePrinciples/financialStatement';
import BalanceSheet from '../../../thePrinciples/financialStatement/balanceSheet';

import ArrowRightBig from './images/icon-arrow-right-big.svg';

export default function IncomeStatementImpact({ onComplete, businessType }) {
  const [showFinancialStatementBalanceSheet, setShowFinancialStatementBalanceSheet] = useState(false);
  
  const [showIntroP, setShowIntroP] = useState(false);
  const [fadeOutIntroP, setFadeOutIntroP] = useState(false);
  const [hideIntroP, setHideIntroP] = useState(false);

  const [showBigArrow, setShowBigArrow] = useState(false);
  
  const [showSecondP, setShowSecondP] = useState(false);
  const [fadeOutSecondP, setFadeOutSecondP] = useState(false);
  const [hideSecondP, setHideSecondP] = useState(false);
  
  const [showThirdP, setShowThirdP] = useState(false);

  const accountImpactedText = !businessType || businessType?.includes('Corporation') ? 'Retained Earnings' : 'Owner\'s Capital';

  useEffect(() => {
    const timeouts = [];
    let currentTime = 0;
    
    currentTime += 500;
    timeouts.push(setTimeout(() => setShowIntroP(true), currentTime));
    
    currentTime += 3000;
    timeouts.push(setTimeout(() => {
      setShowFinancialStatementBalanceSheet(true);
    }, currentTime));
    
    currentTime += 8000;
    timeouts.push(setTimeout(() => {
      setFadeOutIntroP(true);
      setShowSecondP(true);
    }, currentTime));
    
    currentTime += 500;
    timeouts.push(setTimeout(() => {
      setHideIntroP(true);
    }, currentTime));

    currentTime += 3000;
    timeouts.push(setTimeout(() => setShowBigArrow(true), currentTime));

    currentTime += 5000;
    timeouts.push(setTimeout(() => {
      setFadeOutSecondP(true);
      setShowThirdP(true);
    }, currentTime));
    
    currentTime += 500;
    timeouts.push(setTimeout(() => {
      setHideSecondP(true);
    }, currentTime));
    
    currentTime += 8000;

    timeouts.push(setTimeout(() => onComplete?.(), currentTime));
    
    return () => timeouts.forEach(clearTimeout);
  }, [onComplete]);

  return (
    <>
      <h1 className="animate-fade-in">Balanced Equation</h1>
      
      <div className="animation-section">
        {!hideIntroP && (
          <p className={`transition-be-income-statement-impacted-p animation-content ${fadeOutIntroP ? 'animation-content--exiting' : ''} ${getAnimationClass(showIntroP, fadeOutIntroP)}`}>
            In real-world accounting, companies close their <b>Income Statement</b> at the end of each period and carry the resulting balances into the <b>Balance Sheet</b>.
          </p>
        )}

        {showSecondP && !hideSecondP && (
          <p className={`transition-be-income-statement-impacted-p animation-content ${fadeOutSecondP ? 'animation-content--exiting' : ''} ${getAnimationClass(showSecondP, fadeOutSecondP)}`}>
            In this level, you’ll practice and see how <b>Income Statement</b> activities impact the <b>Balance Sheet</b>.
          </p>
        )}

        {showThirdP && (
          <p className={`transition-be-income-statement-impacted-p animation-content ${getAnimationClass(showThirdP)}`}>
            For all transactions that impact the income statement, use the Equity Account to represent revenues and expenses. The specific account impacted is <b>{accountImpactedText}</b>. 
          </p>
        )}
      </div>

      {showFinancialStatementBalanceSheet && (
        <div className="transition-financial-statement-balance-sheet no-stretch">
          <FinancialStatement 
            title="Income Statement"
            revenues={5000}
            expenses={-1000}
          />
          
          
          <div className="animation-content">
            <div className={`transition-financial-statement-balance-sheet-big-arrow-container ${getAnimationClass(showBigArrow)}`}>
              <img src={ArrowRightBig} alt="Arrow right" />
            </div>
          </div>

          <BalanceSheet
            title="Balance Sheet"
            assets={20000}
            liabilities={5000}
            equity={15000}
          />
        </div>
      )}
    </>
  );
}